import { memo } from "react";
import { INewSchedulesTableProps } from "./newModels";
import MySchedulesTable from "./NewMySchedulesTable";
import LinkAccessTable from "./LinkAccessTable";

const NewSchedulesTable: React.FC<INewSchedulesTableProps> = ({
  schedules,
  checkInRule,
  isHistoric,
  basePath,
  allowedAction,
}) => {
  return (
    <>
      {!schedules.isLinkAccess && (
        <MySchedulesTable
          data={schedules.data}
          checkInRule={checkInRule}
          basePath={basePath}
          allowedAction={allowedAction}
        />
      )}

      {schedules.isLinkAccess && (
        <LinkAccessTable data={schedules.data} isHistoric={isHistoric} />
      )}
    </>
  );
};

export default memo(NewSchedulesTable);
